import React, { useEffect, useState } from "react";
import Input from "antd/es/input/Input";
import Banner from "./components/Banner";
import General from "./components/General";
import Notification from "./components/Notification";
import Project from "./components/Project";
import Storage from "./components/Storage";
// import Upload from "./components/Upload";
import { FaEdit } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa6";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Col, Modal, Row } from "antd";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import axios, { Axios } from "axios";
import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import { API_GET_PROFILE } from "api/profile";
import { API_UPDATE_PROFILE } from "api/profile";
import { API_UPLOAD_PROFILE } from "api/profile";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { useDispatch } from "react-redux";
import { profileData } from "store/reducers/userSlice";
import { useTranslation } from "react-i18next";
const ProfileOverview = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [editMode, setEditMode] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [toggleElements, setToggleElements] = useState({
    resetPassword: false,
    editProfile: false,
  });
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [fileList, setFileList] = useState([
    // {
    //   uid: "",
    //   name: "",
    //   status: "",
    //   url: "",
    // },
  ]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (!newFileList?.length > 0) {
      setImage("");
    }
  };

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_PROFILE(formData);

      console.log("result", response, file);

      const newFileList = [
        {
          uid: response.id,
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      console.log(newFileList);
      setFileList(newFileList);
      setImage(response?.file);
      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {/* <Avatar size={64} icon={<UserOutlined />} /> */}

      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Image
      </div>
    </button>
  );

  const handleToggleFields = (name) => {
    setToggleElements({
      resetPassword: !toggleElements?.resetPassword,
      editProfile: false,
    });
  };
  const searchAddress = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    console.log("address", address);
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
      );
      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestions(predictions);
      } else {
        setAutocompleteSuggestions([]);
        // Handle no results or error cases
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };
  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      // Fetch place details using the Place Details request
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedAddress.place_id}&key=${CONSTANTS?.googleApikey}`
      );

      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", postalCode);
        // setFieldValue("location", placeDetails?.formatted_address);
        setFieldValue("location", selectedAddress?.description);

        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);

        console.log("lat long", lat, lng);
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      const newData = await API_GET_PROFILE();
      console.log("profile", newData);
      setData(newData?.data?.data);
      // dispatch(profileData(newData?.data?.data));

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  const handleToggleEditMode = () => {
    setEditMode(!editMode);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (data?.profile_image?.[0]?.file_url) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + data?.profile_image?.[0]?.file_url,
        },
      ]);
      setImage(data?.profile_image);
    }
  }, [data]);
  console.log("data profile", data);
  console.log("fileList", fileList);

  return (
    <div className="ml-2 mt-20 flex h-full w-full flex-col gap-5">
      {/* <h1 className="mt-4">Profile</h1> */}
      <div className="flex h-full w-full flex-row items-center justify-center ">
        <div className="flex min-w-[100%] flex-col gap-5 rounded-2xl border-[1px] bg-white p-12  shadow-md">
          <div className="mb-5 flex items-center justify-between">
            <h1>{t("Profile")}</h1>
            {!editMode ? (
              <button
                onClick={handleToggleEditMode}
                className="flex items-center gap-2 text-brand-500"
              >
                <FaEdit />
                {t("Edit")}
              </button>
            ) : (
              <button
                onClick={handleToggleEditMode}
                className="flex items-center gap-2 text-brand-500"
              >
                <FaRegEye />
                {t("View")}
              </button>
            )}
          </div>
          <div className="mb-3 flex justify-center">
            {editMode ? (
              <div>
              <Upload
                action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                listType="picture-circle"
                customRequest={customRequest}
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
              >
                {fileList.length == 1 ? null : uploadButton}
              </Upload>
                {previewImage && (
              <Image
                wrapperStyle={{
                  display: "none",
                }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(""),
                }}
                src={previewImage}
              />
            )}
              </div>
              
            ) : (
              <div className="flex h-[7rem] w-[7rem]  items-center  justify-center rounded-full border-[1px] p-2">
                <div className="h-[6rem] w-[6rem] overflow-hidden rounded-full">
                  <Image
                    src={fileList[0]?.url}
                    style={{
                      width: "6rem",
                      height: "6rem",
                      borderRadius: "100%",
                    }}
                  />
                </div>
              </div>
            )}
            
          </div>

          <div>
            {/* {toggleElements.resetPassword && ( */}
            <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
              <Formik
                enableReinitialize
                initialValues={
                  process.env.REACT_APP_APPLICATION_NAME === "laundry"
                    ? {
                        first_name: data?.first_name || "",
                        last_name: data?.last_name || "",
                        login_count: data?.login_count || "",
                        description: data?.description || "",
                        phone_number: data?.phone_no || "",
                        role: data?.role || "",
                        user_name: data?.user_name || "",
                        profile_image: data?.profile_image || "",
                        email: data?.email || "",
                        password: data?.unhashed_password || "",
                      }
                    : {
                        first_name: data?.store_name || "",
                        last_name: data?.last_name || "",
                        login_count: data?.login_count || "",
                        description: data?.description || "",
                        phone_number: data?.phone_no || "",
                        role: data?.role || "",
                        user_name: data?.user_name || "",
                        profile_image: data?.profile_image || "",
                        email: data?.email || "",
                        password: data?.unhashed_password || "",
                      }
                }
                validationSchema={Yup.object({
                  // first_name: Yup.string().required("Required"),
                  // last_name: Yup.string().required("Required"),
                  // login_count: Yup.number(),
                  // description: Yup.string().required("Required"),
                  // phone_number: Yup.string().required("Required"),
                  // role: Yup.string(),
                  // // user_name: Yup.string(),
                  // // profile_image: Yup.string(),
                  // email: Yup.string()
                  //   .email("Invalid email format")
                  //   .required("Required"),
                  // // password: Yup.string().required("Required"),
                })}
                onSubmit={async (values, { setSubmitting, setFieldError }) => {
                  console.log("values", values);
                  setValuesData(values);
                  setConfirmModalVisible(true);

                  // try {
                  //   const { profile_image, ...data } = values;
                  //   // const latLng = `${location_lat},${location_lng}`;

                  //   const payload = {
                  //     ...data,
                  //     profile_image: image,
                  //   };
                  //   const userData = await API_UPDATE_PROFILE(payload);
                  //   if (userData) {
                  //     fetchData();
                  //     toast.success("Profile Updated");
                  //   }
                  // } catch (error) {
                  //   console.error("error", error);
                  //   toast.error(error?.response?.data?.message);
                  // } finally {
                  //   setSubmitting(false);
                  // }
                }}
              >
                {({ isSubmitting, values, setFieldValue }) => (
                  <Form className="w-full">
                    {editMode ? (
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <div className="mb-3">
                            <label
                              className="font-bold"
                              style={{ fontWeight: "700" }}
                            >
                              {t("Name")} <span className="text-[red]">*</span>
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="text"
                              name="first_name"
                              placeholder={t("Name")}
                              onKeyPress={(event) => {
                                const charCode = event.charCode;
                                if (
                                  !(charCode >= 65 && charCode <= 90) && // A-Z
                                  !(charCode >= 97 && charCode <= 122) && // a-z
                                  charCode !== 32 // space
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              maxLength={20}
                            />
                            <ErrorMessage
                              name="first_name"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>

                        {/* <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Last Name")}{" "}
                              <span className="text-[red]">*</span>
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="text"
                              name="last_name"
                              placeholder={t("Last Name")}
                              onKeyPress={(event) => {
                                const charCode = event.charCode;
                                if (
                                  !(charCode >= 65 && charCode <= 90) && // A-Z
                                  !(charCode >= 97 && charCode <= 122) && // a-z
                                  charCode !== 32 // space
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              maxLength={20}
                            />
                            <ErrorMessage
                              name="last_name"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col> */}
                        {console.log("valuessss", values)}

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Login Count")}
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="number"
                              name="login_count"
                              placeholder={t("Login Count")}
                            />
                            <ErrorMessage
                              name="login_count"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>
                        {/* 
                      <Col span={8}>
                        <div className="mb-3">
                          <label>
                            Description <span className="text-[red]">*</span>
                          </label>
                          <Field
                            className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                            // component="textarea"
                            name="description"
                            placeholder="Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="text-red-500"
                          />
                        </div>
                      </Col> */}

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Phone Number")}
                              <span className="text-[red]">*</span>
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="text"
                              name="phone_number"
                              placeholder={t("Phone Number")}
                            />
                            <ErrorMessage
                              name="phone_number"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">{t("Role")}</label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="text"
                              name="role"
                              placeholder={t("Role")}
                              onKeyPress={(event) => {
                                const charCode = event.charCode;
                                if (
                                  !(charCode >= 65 && charCode <= 90) && // A-Z
                                  !(charCode >= 97 && charCode <= 122) && // a-z
                                  charCode !== 32 // space
                                ) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            <ErrorMessage
                              name="role"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("User Name")}
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="text"
                              name="user_name"
                              placeholder={t("User Name")}
                            />
                            <ErrorMessage
                              name="user_name"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>
                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Email")} <span className="text-[red]">*</span>
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type="text"
                              name="email"
                              placeholder={t("Email")}
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>

                        <Col span={8}>
                          <div className="relative mb-3">
                            <label className="font-bold">
                              {t("Password")}{" "}
                              <span className="text-[red]">*</span>
                            </label>
                            <Field
                              className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                              type={showPassword ? "text" : "password"}
                              name="password"
                              placeholder={t("Password")}
                              autocomplete="new-password"
                            />
                            <button
                              type="button"
                              onClick={() =>
                                setShowPassword((prevState) => !prevState)
                              }
                              className="absolute bottom-[-20px] right-4 top-3"
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                            </button>
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="text-red-500"
                            />
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Name")} <span className="text-[red]">*</span>
                            </label>

                            <div className="mt-3 w-full">
                              {process.env.REACT_APP_APPLICATION_NAME ===
                              "laundry"
                                ? data?.first_name
                                : data?.store_name}
                            </div>
                          </div>
                        </Col>

                        {/* <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Last Name")}{" "}
                              <span className="text-[red]">*</span>
                            </label>
                            <div className="mt-3 w-full">
                              {data?.last_name ? data?.last_name : "-"}
                            </div>
                          </div>
                        </Col> */}

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Login Count")}
                            </label>
                            <div className="mt-3 w-full">
                              {data?.login_count ? data?.login_count : "-"}
                            </div>
                          </div>
                        </Col>
                        {/* 
                      <Col span={8}>
                        <div className="mb-3">
                          <label>
                            Description <span className="text-[red]">*</span>
                          </label>
                          <Field
                            className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                            // component="textarea"
                            name="description"
                            placeholder="Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="text-red-500"
                          />
                        </div>
                      </Col> */}

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Phone Number")}
                              <span className="text-[red]">*</span>
                            </label>
                            <div className="mt-3 w-full">
                              {data?.phone_no ? data?.phone_no : "-"}
                            </div>
                          </div>
                        </Col>

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">{t("Role")}</label>
                            <div className="mt-3 w-full">
                              {data?.role ? data?.role : "-"}
                            </div>
                          </div>
                        </Col>

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("User Name")}
                            </label>
                            <div className="mt-3 w-full">
                              {data?.user_name ? data?.user_name : "-"}
                            </div>
                          </div>
                        </Col>
                        {/* <Col span={8}>
                        <div className="mb-3">
                          <label>Profile Image</label>
                          <Field
                            className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                            type="text"
                            name="profile_image"
                            placeholder="Profile Image"
                          />
                          <ErrorMessage
                            name="profile_image "
                            component="div"
                            className="text-red-500"
                          />
                        </div>
                      </Col> */}
                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Email")} <span className="text-[red]">*</span>
                            </label>
                            <div className="mt-3">
                              {data?.email ? data?.email : "-"}
                            </div>
                          </div>
                        </Col>

                        <Col span={8}>
                          <div className="mb-3">
                            <label className="font-bold">
                              {t("Password")}{" "}
                              <span className="text-[red]">*</span>
                            </label>
                            <div className="flex justify-between">
                              <div>
                                {showPassword
                                  ? data?.unhashed_password
                                  : "*".repeat(data?.unhashed_password?.length)}
                              </div>
                              <div
                                type="button"
                                onClick={() =>
                                  setShowPassword((prevState) => !prevState)
                                }
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                              </div>
                            </div>
                            {/* <div className="mt-3 w-full">
                              {data?.password ? data?.password : "-"}
                            </div> */}
                          </div>
                        </Col>
                      </Row>
                    )}
                    {editMode && (
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="linear p-[4px 11px] ml-auto  mt-8 flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white  hover:text-brand-500 dark:bg-brand-400 dark:text-white dark:active:bg-brand-200"
                      >
                        {isSubmitting
                          ? t("Updating") + "..."
                          : t("Update Profile")}
                      </button>
                    )}
                  </Form>
                )}
              </Formik>
              {/* Confirmation Modal */}
              <Modal
                // title="Save Changes"
                visible={confirmModalVisible}
                onCancel={() => setConfirmModalVisible(false)}
                centered
                onOk={async () => {
                  setConfirmModalVisible(false);
                  try {
                    const { profile_image, ...data } = valuesData;
                    // const latLng = `${location_lat},${location_lng}`;

                    const payload = {
                      ...data,
                      profile_image: image,
                    };
                    const userData = await API_UPDATE_PROFILE(payload);
                    if (userData) {
                      fetchData();
                      toast.success("Profile Updated");
                    }
                  } catch (error) {
                    console.error("error", error);
                    toast.error(error?.response?.data?.message);
                  } finally {
                    // setSubmitting(false);
                  }
                }}
              >
                <div
                  className="flex items-center"
                  style={{ flexDirection: "column" }}
                >
                  <div>
                    <p className="mb-1 font-bold">Save Changes</p>
                    <p className="mb-8 font-medium">
                      Do you want to Save Changes before leaving the Page?
                    </p>
                  </div>
                  <div className="flex gap-4">
                    <button
                      className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                      onClick={() => setConfirmModalVisible(false)}
                      style={{ width: "6rem" }}
                    >
                      Cancel
                    </button>
                    <button
                      className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                      onClick={async () => {
                        setConfirmModalVisible(false);
                        try {
                          const {
                            profile_image,
                            phone_number,
                            first_name,
                            ...data
                          } = valuesData;
                          // const latLng = `${location_lat},${location_lng}`;

                          const payload = {
                            ...data,
                            profile_image: image,
                            phone_no: phone_number,
                            ...(process.env.app === "laundry"
                              ? { laundry_name: first_name }
                              : { store_name: first_name }),
                          };
                          const userData = await API_UPDATE_PROFILE(payload);
                          if (userData) {
                            fetchData();
                            toast.success("Profile Updated");
                            setEditMode(false);
                          }
                        } catch (error) {
                          console.error("error", error);
                          toast.error(error?.response?.data?.message);
                        } finally {
                          // setSubmitting(false);
                        }
                      }}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileOverview;
